import { CLOSED_STAGES } from '@/shared/domain'
import type { LeadRow } from '@/shared/types'

const CLOSED = new Set<string>(CLOSED_STAGES)

export interface SoonToday {
  /** Open leads promised later today — the BAND.SOON slice of the seller's book. */
  count: number
  /** ISO timestamp of the earliest one, or null when none are due today. */
  nextAt: string | null
}

/**
 * Open leads with a promised callback later today — not due now (that's
 * BAND.DUE, already in the queue) and not promised tomorrow or later (BAND.WAITING).
 * Mirrors the window `bandOf` in useLeadsData uses, so the done screen's count
 * can never disagree with how the queue itself bands the same leads.
 */
export function soonToday(leads: LeadRow[], now: number = Date.now()): SoonToday {
  const endOfDay = new Date(now)
  endOfDay.setHours(23, 59, 59, 999)
  const upcoming = leads
    .filter(l => !CLOSED.has(l.stage))
    .map(l => (l.nextContactAt ? Date.parse(l.nextContactAt) : NaN))
    .filter(t => !Number.isNaN(t) && t > now && t <= endOfDay.getTime())
    .sort((a, b) => a - b)
  return {
    count: upcoming.length,
    nextAt: upcoming.length > 0 ? new Date(upcoming[0]).toISOString() : null,
  }
}
